import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from 'react';
import { FLAVOURS, FLAVOUR_ORDER } from '../data/mock';
import { track } from '../lib/analytics';

const FlavourContext = createContext(null);

export function FlavourProvider({ children }) {
  const [flavourId, setFlavourId] = useState(() => localStorage.getItem('sman_flavour') || 'strawberry');
  const [pulse, setPulse] = useState(0);
  const pulseTimer = useRef(null);

  const applyVars = useCallback((id) => {
    const f = FLAVOURS[id];
    if (!f) return;
    const root = document.documentElement.style;
    root.setProperty('--flavour-primary', f.primary);
    root.setProperty('--flavour-secondary', f.secondary);
    root.setProperty('--flavour-rgb', f.rgb);
  }, []);

  useEffect(() => { applyVars(flavourId); }, [flavourId, applyVars]);

  const setFlavour = useCallback((id, source = 'unknown') => {
    if (!FLAVOURS[id]) return;
    setFlavourId(id);
    localStorage.setItem('sman_flavour', id);
    applyVars(id);
    setPulse((p) => p + 1);
    if (pulseTimer.current) clearTimeout(pulseTimer.current);
    pulseTimer.current = setTimeout(() => {}, 700);
    track('flavour_selected', { flavour: id, source });
  }, [applyVars]);

  const next = useCallback(() => {
    const i = FLAVOUR_ORDER.indexOf(flavourId);
    setFlavour(FLAVOUR_ORDER[(i + 1) % FLAVOUR_ORDER.length], 'swipe');
  }, [flavourId, setFlavour]);

  const prev = useCallback(() => {
    const i = FLAVOUR_ORDER.indexOf(flavourId);
    setFlavour(FLAVOUR_ORDER[(i - 1 + FLAVOUR_ORDER.length) % FLAVOUR_ORDER.length], 'swipe');
  }, [flavourId, setFlavour]);

  const flavour = FLAVOURS[flavourId];

  return (
    <FlavourContext.Provider value={{ flavourId, flavour, setFlavour, next, prev, pulse, order: FLAVOUR_ORDER, all: FLAVOURS }}>
      {children}
    </FlavourContext.Provider>
  );
}

export const useFlavour = () => useContext(FlavourContext);
